




















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { STATUSES as SERVICE_REQUEST_STATUSES } from '@/constants/service_request';
import ServiceRequestListFilterForm from './List/ServiceRequestListFilterForm.vue';
import ServiceRequestListFilterChip from './List/ServiceRequestListFilterChip.vue';
import { jsonToQueryString } from '../../../utils/utils';

@Component({
  components: {
    ServiceRequestListFilterForm,
    ServiceRequestListFilterChip,
  },
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
  },
})
export default class ServiceRequestList extends Vue {
  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
    statuses: [],
    candidateName: null,
  };
  serviceRequestStatues = SERVICE_REQUEST_STATUSES;
  resetPage = false;
  business!: Model;

  headers = [
    { text: 'Request', value: 'object_id' },
    {
      text: 'Status',
      value: 'status',
      align: 'left',
      sortable: false,
      width: '15%',
    },
    // { text: 'Actions', value: 'actions', align: 'left', sortable: false },
  ];

  @Watch('options', { immediate: false })
  watchOptions(newVal, oldVal) {
    this.resetPage =
      oldVal.query != newVal.query ||
      oldVal.candidateName != newVal.candidateName ||
      oldVal.statuses != newVal.statuses;

    this.options.page = this.resetPage ? 1 : this.options.page;

    history.pushState(
      {},
      '',
      this.$route.path +
        '?' +
        jsonToQueryString({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          candidateName: this.options.candidateName,
          statuses: this.options.statuses,
          query: this.options.query,
          orderBy: this.options.orderBy,
          orderByDirection: this.options.orderByDirection,
        })
    );
  }

  handleFetch() {
    const options = {
      params: {
        search: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        candidate_name: this.options.candidateName,
        expand: [
          'service_candidates.booking_candidate',
          'service_candidates.service_item',
        ],
      },
    };
    if (this.business) {
      options.params['business_oid'] = this.business.object_id;
    }
    return this.$store.dispatch('ServiceRequest/fetchList', options);
  }

  toRead(oid) {
    const routeData = this.$router.resolve({
      name: 'business-service-request-read',
      params: {
        serviceRequestOid: oid,
      },
    });
    window.open(routeData.href, '_blank');
  }

  handleClick(item) {
    this.toRead(item.object_id);
  }
}
